import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap'
import { sortBy, isEqual } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import { ApiServiceServerless } from '../../../../xhr_libs';
import ConfirmationModal, { useConfirm } from '../../../../components/modals/ConfirmationModal';
import EditEntityActionButtons from '../../../../components/forms/EditEntityActionButtons';
import { useOrganizationRoles } from '../../../../helpers/checkRoles';
import CHARTCOLORS from '../../../../helpers/chartColors';
import BuildingSelectModal from '../../../../components/modals/BuildingSelectModal';
import Loader from '../../../../components/Loader';
import AddBuildingGroupModal from '../../../../components/modals/AddBuildingGroupModal';


export default function OrganizationGroups(props) {
  const {
    organization,
    userSelectedOrganizationDetails,
    building_groups,
    isLoading,
    showToast,
    setOrganization,
  } = props;


  const [activeGroupId, setActiveGroupId] = useState(0);
  const [activeGroup, setActiveGroup] = useState({})
  const [editGroup, setEditGroup] = useState({})
  const [actionsDisabled, setActionsDisabled] = useState(true);

  const [buildings, setBuildings] = useState([])
  const [buildingIds, setBuildingIds] = useState([]);
  const [selectedBuildings, setSelectedBuildings] = useState([]);
  const [selectedString, setSelectedString] = useState('');

  const [showAddModal, setShowAddModal] = useState(false);
  const [showBuildingModal, setShowBuildingModal] = useState(false);

  const [confirmationModalProps, withConfirm] = useConfirm();

  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const updateAccess = useOrganizationRoles(
    userSelectedOrganizationDetails,
    'organization',
    'update'
  );

  useEffect(() => {
    setBuildings(organization.buildings)
    setBuildingIds(organization.buildings.map((building) => building.id))

    if (activeGroupId !== null && activeGroupId !== 0) {
      let group = organization.building_groups.find(
        (group) => group.id === activeGroupId
      )
      setActiveGroup(group);
      setEditGroup(group);
      setSelectedBuildings(group.building_ids)
    } else {
      setActiveGroup({});
      setEditGroup({});
    }
  }, [organization, activeGroupId]);

  useEffect(() => {
    let building_arr = []
    for (let i = 0; i < selectedBuildings.length; i++) {
      let building = buildings.find((building) => building.id === selectedBuildings[i])
      if (building) {
        building_arr.push(building.name);
      }
    }
    setSelectedString(building_arr.join(','));
  }, [selectedBuildings, buildings]);


  const onFieldChange = useCallback((fieldName, value) => {
    setEditGroup((group) => {
      group[fieldName] = value;
      return { ...group };
    });
  }, []);

  const saveGroup = (e) => {
    e.preventDefault();
    const payload = editGroup
    payload['building_ids'] = selectedBuildings
    ApiServiceServerless.post(
      `/organizations/${organization.id}/groups/${activeGroup.id}`,
      payload,
      { authorization_id: organization.id }
    )
      .then((res) => {
        setOrganization((prev) => ({
          ...prev,
          building_groups: prev.building_groups.map((group) => {
            if (group['id'] !== res.data['id']) return group;
            return res.data;
          }),
        }));
        setActiveGroup(res.data)
        showToast('success', 'Success', 'Group Saved');
        setIsSaving(false);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        setIsSaving(false);
      });

  }

  const handleDelete = () => {
    const msg = `Are you sure you want to delete this Group? This cannot be undone.`;
    withConfirm(msg, () => {
      deleteGroup();
    });
  };

  const deleteGroup = () => {
    setIsDeleting(true);
    ApiServiceServerless.delete(
      `/organizations/${organization.id}/groups/${activeGroup.id}`,
      { authorization_id: organization.id }
    )
      .then(() => showToast('success', 'Success', 'Contact Deleted'))
      .catch((error) => {
        showToast('danger', 'Error', error);
      })
      .finally(() => {
        setActiveGroupId(0)
        setOrganization((prev) => ({
          ...prev,
          building_groups: prev.building_groups.filter((group) => group.id !== activeGroup.id),
        }));
        setIsDeleting(false);
      });
  };

  const clearChanges = () => {
    setEditGroup({ ...activeGroup });
  };

  useEffect(() => {
    let disabled = true;

    if (Object.keys(activeGroup).length > 0 && Object.keys(editGroup).length > 0) {
      if (activeGroup.name !== editGroup.name || !isEqual(activeGroup.building_ids, selectedBuildings)) {
        disabled = false
      }
    }
    setActionsDisabled(disabled);
  }, [activeGroup, editGroup, selectedBuildings]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Row style={{ margin: 0 }}>
            <Col style={{ display: 'inline-flex' }}>
              <Row>
                <Form inline style={{ marginBottom: '0.5em' }}>
                  <Form.Label
                    style={{
                      display: 'block',
                      marginRight: '0.5em',
                      marginLeft: '0.5em',
                    }}
                  >
                    Building Group:
                  </Form.Label>
                  <Form.Control
                    style={{ float: 'right' }}
                    as='select'
                    size='sm'
                    value={activeGroupId ? activeGroupId : 0}
                    onChange={(e) => {
                      setActiveGroupId(parseInt(e.target.value));
                    }}
                  >
                    <option hidden value={'null'} key={'null-opt'}>
                      Select a Group
                    </option>
                    {building_groups && building_groups.length === 0 && (
                      <option disabled value={'null'} key={'null-null'}>
                        No Groups
                      </option>
                    )}
                    {sortBy(building_groups, ['name']).map((group) => (
                      <option
                        key={`group-opt-${group.id}`}
                        value={group.id}
                      >
                        {group.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form>
              </Row>
              <Row style={{ marginLeft: '50px' }}>
                {updateAccess && (
                  <Button
                    onClick={() => {
                      setShowAddModal(true);
                    }}
                    style={{ marginBottom: '1em', float: 'right' }}
                  >
                    Add Building Group
                  </Button>
                )}

              </Row>
            </Col>
          </Row>
          {activeGroup.id &&
            <Row style={{ marginTop: '20px' }}>
              <Col md={3}></Col>
              <Col md={5}>
                <Form noValidate onSubmit={saveGroup}>
                  <Form.Group controlId='group.name'>
                    <Form.Label>
                      Group Name
                      <span className='text-warning font-weight-bold pl-1'>
                        *
                      </span>
                    </Form.Label>
                    <Form.Control
                      required
                      value={editGroup.name || ''}
                      disabled={!updateAccess}
                      onChange={(e) => onFieldChange('name', e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group controlId='group.buildings'>
                    <Form.Label>
                      Select Buildings
                      <span className='text-warning font-weight-bold pl-1'>
                        *
                      </span>
                    </Form.Label>
                    <Form.Control
                      required
                      value={
                        buildings.length === selectedBuildings.length
                          ? 'All Buildings'
                          : selectedString
                      }
                      disabled={true}
                      style={{ paddingRight: '5%' }}
                    />
                    <FontAwesomeIcon
                      style={{
                        fontSize: '20px',
                        marginLeft: '0.5em',
                        color: CHARTCOLORS[1],
                        cursor: 'pointer',
                        float: 'right',
                        marginTop: '-29px',
                        marginRight: '5px',
                      }}
                      icon={faEdit}
                      id={`report-building-select-popover`}
                      onClick={() => setShowBuildingModal(true)}
                    />
                  </Form.Group>
                  <EditEntityActionButtons
                    onSubmit={saveGroup}
                    onCancel={clearChanges}
                    onDelete={handleDelete}
                    submitDisabled={actionsDisabled}
                    cancelDisabled={actionsDisabled}
                    submitShow={updateAccess}
                    deleteShow={updateAccess}
                    isSubmitting={isSaving}
                    isDeleting={isDeleting}
                  />
                </Form>
              </Col>
              <Col md={4}></Col>
              <BuildingSelectModal
                show={showBuildingModal}
                onHide={() => setShowBuildingModal(false)}
                buildings={buildings}
                buildingIds={buildingIds}
                selectedBuildings={selectedBuildings}
                setSelectedBuildings={setSelectedBuildings}
                setNonSelectedBuildings={() => { }}
              />
            </Row>
          }
          <AddBuildingGroupModal
            show={showAddModal}
            onHide={() => { setShowAddModal(false) }}
            organization_id={organization.id}
            building_ids={buildingIds}
            showToast={showToast}
            setActiveGroup={setActiveGroup}
            setActiveGroupId={setActiveGroupId}
            setOrganization={setOrganization}
          />
          <ConfirmationModal {...confirmationModalProps} />
        </>)}
    </>)
}